var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import { PrivateContext } from './IdentityProvider';
import PostAuthCallback from './PostAuthCallback';
function attemptLogin({ authService, postAuthCallback, privateDispatch }) {
    return __awaiter(this, void 0, void 0, function* () {
        console.log('calling signIn()');
        const user = yield authService.signIn();
        if (user) {
            PostAuthCallback({ postAuthCallback, privateDispatch, user });
        }
    });
}
export default function Login() {
    const { privateState, privateDispatch } = useContext(PrivateContext);
    const { postAuthCallback } = privateState;
    const [running, setRunning] = useState(false);
    console.log('legacyMode', privateState.legacyMode);
    useEffect(() => {
        if (privateState.legacyMode) {
            window.location.href = '/oauth/main/login';
        }
        else if (privateState.authService && !running) {
            setRunning(true);
            attemptLogin({ authService: privateState.authService, postAuthCallback, privateDispatch });
        }
    });
    if (privateState.debugMode === true) {
        return React.createElement("h1", null, "attempting login");
    }
    return null;
}
